module.exports = {"id":"230170","name":"Jaim Abra","rating":"73","photo":"./data/images/photos/2/230170.png","club":{"name":"Vitória","logo":"./data/images/clubs/Vitoria.png"},"positions":["G"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JaimAbra0.json
// module id = 1875
// module chunks = 0